'use client';
import { Root as $f99a8c78507165f7$export$be92b6f5f03c0fe9, Item as $f99a8c78507165f7$export$6d08773d2e66f8f2, Indicator as $f99a8c78507165f7$export$adb584737d712b70, RadioGroup as $f99a8c78507165f7$export$a98f0dcb43a68a25, RadioGroupItem as $f99a8c78507165f7$export$9f866c100ef519e4, RadioGroupIndicator as $f99a8c78507165f7$export$5fb54c671a65c88, createRadioGroupScope as $f99a8c78507165f7$export$c547093f11b76da2 } from '../../external/@radix-ui/react-radio-group/dist/index.js';

var Root = $f99a8c78507165f7$export$be92b6f5f03c0fe9;
var Item = $f99a8c78507165f7$export$6d08773d2e66f8f2;
var Indicator = $f99a8c78507165f7$export$adb584737d712b70;
var RadioGroup = $f99a8c78507165f7$export$a98f0dcb43a68a25;
var RadioGroupItem = $f99a8c78507165f7$export$9f866c100ef519e4;
var RadioGroupIndicator = $f99a8c78507165f7$export$5fb54c671a65c88;
var createRadioGroupScope = $f99a8c78507165f7$export$c547093f11b76da2;

export { Indicator, Item, RadioGroup, RadioGroupIndicator, RadioGroupItem, Root, createRadioGroupScope };
